import { IAbroadInsuranceInitialValues } from '../../../types';

export const INITIAL_VALUES: IAbroadInsuranceInitialValues = {
  id: undefined,
  upload_files: [],
  email_users: [],
  recent_status: '',
  organization: 0,
  policy_number: undefined,
  start_date: '',
  end_date: '',
  description: '',
  country: '',
  branch: '',
};
